var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};

// src/init-module.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/asset-map.ts
import leagueLogo from "./assets/league-logo-icon.svg";
import leagueLogoSubdued from "./assets/league-logo-icon-subdued.svg";
import challengeTokenSubdued from "./assets/challenge-token-subdued.svg";

// src/components/challenge-token-icon/challenge-token-asset.component.tsx
import React from "react";

// src/utils/styled-svg.component.tsx
import { genesisStyled, css } from "@leagueplatform/genesis-commons";
var StyledSVG = genesisStyled.svg(
  ({ size }) => css({
    width: size,
    height: size
  })
);

// src/utils/styled-path.component.tsx
import {
  genesisStyled as genesisStyled2,
  css as css2
} from "@leagueplatform/genesis-commons";
var StyledPath = genesisStyled2.path(
  ({ fillColor, strokeColor }) => css2(__spreadValues({
    fill: fillColor
  }, strokeColor && { stroke: strokeColor }))
);

// src/components/challenge-token-icon/challenge-token-asset.component.tsx
var ChallengeTokenAsset = ({
  circleColor = "warning.icon",
  starColor = "warning.background.secondary",
  size = "threeQuarters"
}) => /* @__PURE__ */ React.createElement(
  StyledSVG,
  {
    size,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "tokenIcon"
  },
  /* @__PURE__ */ React.createElement(
    StyledPath,
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 16C12.1421 16 15.5 12.6421 15.5 8.5C15.5 4.35786 12.1421 1 8 1C3.85786 1 0.5 4.35786 0.5 8.5C0.5 12.6421 3.85786 16 8 16Z",
      fillColor: circleColor,
      strokeColor: circleColor,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    StyledPath,
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.47858 4.78666L9.50658 7.00199H11.5066C11.7132 6.99388 11.9027 7.11639 11.9802 7.30817C12.0576 7.49994 12.0063 7.71968 11.8519 7.85732L10.1186 9.56532L11.0806 11.7747C11.1667 11.9821 11.111 12.2213 10.9422 12.3694C10.7735 12.5175 10.5291 12.5416 10.3346 12.4293L8.00991 11.122L5.68258 12.4293C5.48811 12.5416 5.2437 12.5175 5.07491 12.3694C4.90612 12.2213 4.85048 11.9821 4.93658 11.7747L5.89858 9.56666L4.16525 7.85866C4.00965 7.72201 3.95691 7.50222 4.03356 7.30985C4.11021 7.11748 4.29965 6.99418 4.50658 7.00199H6.50658L7.53325 4.78666C7.62522 4.61068 7.80735 4.50037 8.00591 4.50037C8.20448 4.50037 8.3866 4.61068 8.47858 4.78666Z",
      fillColor: starColor
    }
  )
);

// src/asset-map.ts
import rewardProgramPoints from "./assets/reward-program-points.svg";
import rewardProgramPointsSubdued from "./assets/reward-program-points-subdued.svg";
var REWARDS_COMMON_ASSET_KEYS = /* @__PURE__ */ ((REWARDS_COMMON_ASSET_KEYS2) => {
  REWARDS_COMMON_ASSET_KEYS2["REWARDS_POINTS"] = "REWARDS_POINTS";
  REWARDS_COMMON_ASSET_KEYS2["REWARDS_POINTS_SUBDUED"] = "REWARDS_POINTS_SUBDUED";
  REWARDS_COMMON_ASSET_KEYS2["REWARDS_CHALLENGE_TOKEN"] = "REWARDS_CHALLENGE_TOKEN";
  REWARDS_COMMON_ASSET_KEYS2["REWARDS_CHALLENGE_TOKEN_SUBDUED"] = "REWARDS_CHALLENGE_TOKEN_SUBDUED";
  REWARDS_COMMON_ASSET_KEYS2["REWARDS_PROGRAM_POINTS"] = "REWARDS_PROGRAM_POINTS";
  REWARDS_COMMON_ASSET_KEYS2["REWARDS_PROGRAM_POINTS_SUBDUED"] = "REWARDS_PROGRAM_POINTS_SUBDUED";
  return REWARDS_COMMON_ASSET_KEYS2;
})(REWARDS_COMMON_ASSET_KEYS || {});
var REWARDS_COMMON_ASSETS_MAP = {
  REWARDS_POINTS: leagueLogo,
  REWARDS_POINTS_SUBDUED: leagueLogoSubdued,
  REWARDS_CHALLENGE_TOKEN: ChallengeTokenAsset,
  REWARDS_CHALLENGE_TOKEN_SUBDUED: challengeTokenSubdued,
  REWARDS_PROGRAM_POINTS: rewardProgramPoints,
  REWARDS_PROGRAM_POINTS_SUBDUED: rewardProgramPointsSubdued
};

// src/init-module.ts
var initModule = () => {
  setDefaultAssets(REWARDS_COMMON_ASSETS_MAP);
};

// src/components/challenge-token-icon/challenge-token-icon.component.tsx
import React2 from "react";
import { useIntl } from "@leagueplatform/locales";
import { handleStaticAsset } from "@leagueplatform/asset-config";
import {
  StackLayout,
  UtilityText,
  VisuallyHidden
} from "@leagueplatform/genesis-core";
import {
  CoverImage
} from "@leagueplatform/genesis-commons";
var ChallengeTokenIcon = ({
  circleColor = "warning.icon",
  starColor = "warning.background.secondary",
  size = "threeQuarters",
  value,
  altText,
  subdued
}) => {
  const { formatMessage, formatNumber } = useIntl();
  const { REWARDS_CHALLENGE_TOKEN, REWARDS_CHALLENGE_TOKEN_SUBDUED } = REWARDS_COMMON_ASSET_KEYS;
  const componentOptions = {
    isComponent: true,
    props: {
      circleColor,
      starColor,
      size
    }
  };
  const tokenIcon = subdued ? /* @__PURE__ */ React2.createElement(
    CoverImage,
    {
      src: handleStaticAsset(REWARDS_CHALLENGE_TOKEN_SUBDUED),
      alt: "",
      size
    }
  ) : handleStaticAsset(REWARDS_CHALLENGE_TOKEN, componentOptions);
  return /* @__PURE__ */ React2.createElement(
    StackLayout,
    {
      orientation: "horizontal",
      spacing: "$quarter",
      verticalAlignment: "center"
    },
    tokenIcon,
    /* @__PURE__ */ React2.createElement(VisuallyHidden, null, altText || formatMessage({ id: "X_TOKENS" }, { tokenCount: value })),
    /* @__PURE__ */ React2.createElement(
      UtilityText,
      {
        css: {
          color: "inherit",
          fontWeight: "inherit",
          fontSize: "inherit"
        },
        "aria-hidden": true
      },
      formatNumber(value)
    )
  );
};

// src/components/points-icon/points-icon.component.tsx
import React3 from "react";
import { handleStaticAsset as handleStaticAsset2 } from "@leagueplatform/asset-config";
import { Image } from "@leagueplatform/genesis-commons";
import { StackLayout as StackLayout2, UtilityText as UtilityText2 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl2 } from "@leagueplatform/locales";
var PointsIcon = ({
  subdued,
  size = "threeQuarters",
  altText,
  value
}) => {
  const pointsIcon = handleStaticAsset2(
    subdued ? "REWARDS_POINTS_SUBDUED" /* REWARDS_POINTS_SUBDUED */ : "REWARDS_POINTS" /* REWARDS_POINTS */
  );
  const { formatMessage, formatNumber } = useIntl2();
  return /* @__PURE__ */ React3.createElement(
    StackLayout2,
    {
      orientation: "horizontal",
      spacing: "$quarter",
      verticalAlignment: "center"
    },
    /* @__PURE__ */ React3.createElement(
      Image,
      {
        size,
        src: pointsIcon,
        alt: altText || formatMessage({ id: "X_POINTS" }, { points: value })
      }
    ),
    /* @__PURE__ */ React3.createElement(
      UtilityText2,
      {
        css: {
          color: "inherit",
          fontWeight: "inherit",
          fontSize: "inherit"
        },
        "aria-hidden": true
      },
      formatNumber(value)
    )
  );
};

// src/components/reward-points-icon/reward-points-icon.component.tsx
import React4 from "react";
import { handleStaticAsset as handleStaticAsset3 } from "@leagueplatform/asset-config";
import { Icon, StackLayout as StackLayout3, UtilityText as UtilityText3 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl3 } from "@leagueplatform/locales";
var RewardPointsIcon = ({
  iconUrl,
  subdued,
  altText,
  value,
  pointsText
}) => {
  const pointsIcon = handleStaticAsset3(
    "REWARDS_PROGRAM_POINTS" /* REWARDS_PROGRAM_POINTS */
  );
  const { formatNumber } = useIntl3();
  let valueColor = "$onSurfaceTextSuccess";
  if (subdued) {
    valueColor = "$onSurfaceTextSubdued";
  } else if (pointsText) {
    valueColor = "$onSurfaceTextPrimary";
  }
  return /* @__PURE__ */ React4.createElement(
    StackLayout3,
    {
      orientation: "horizontal",
      spacing: "$quarter",
      verticalAlignment: "center"
    },
    /* @__PURE__ */ React4.createElement(
      Icon,
      {
        css: { filter: `saturate(${subdued ? 0 : 1})` },
        size: "$one",
        icon: iconUrl || pointsIcon,
        label: altText
      }
    ),
    /* @__PURE__ */ React4.createElement(
      UtilityText3,
      {
        css: {
          color: valueColor,
          fontWeight: subdued ? "normal" : "bold",
          fontSize: "inherit",
          whiteSpace: "nowrap"
        }
      },
      formatNumber(value)
    ),
    /* @__PURE__ */ React4.createElement(
      UtilityText3,
      {
        css: {
          color: "$onSurfaceTextPrimary",
          fontWeight: "bold",
          fontSize: "inherit"
        }
      },
      pointsText
    )
  );
};

// src/index.ts
initModule();
export {
  ChallengeTokenIcon,
  PointsIcon,
  RewardPointsIcon
};
//# sourceMappingURL=index.js.map